import { useCallback, useMemo, useState } from 'react';

import ConfirmationModal from '../../components/core/ConfirmationModal';

import IConfirmationParams from './types';

function useConfirmation<P = void>(options: IConfirmationParams<P>) {
  const [visible, setVisible] = useState(false);
  const [params, setParams] = useState<P>();

  const show = useCallback((newParams: P) => {
    setParams(newParams);
    setVisible(true);
  }, []);

  const { onClose, onConfirm, ...restProps } = options;

  const onHookClose = useCallback(() => {
    setVisible(false);
    onClose(params as P);
  }, [onClose, params]);

  const onHookConfirm = useCallback(() => {
    setVisible(false);
    onConfirm(params as P);
  }, [onConfirm, params]);

  const element = useMemo(() => {
    return visible ? (
      <ConfirmationModal {...restProps} onClose={onHookClose} onConfirm={onHookConfirm} />
    ) : null;
  }, [onHookClose, onHookConfirm, restProps, visible]);

  return [element, show] as const;
}

export default useConfirmation;
